import React from 'react'
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import MainLayout from '../layout/MainLayout';
import CommentList from '../components/CommentList';
import { Link } from 'react-router-dom';
import VoteTile from '../components/VoteTile';

function HouseSideBySide() {
    const { year, state, district } = useParams();

    const noWebsiteMessage = 'This candidate does not have a public website so we are unable to provide analysis.';
    const [candidates, setCandidates] = useState([]);
    const [votes, setVotes] = useState([0, 0]);

    const [alreadyVoted, setAlreadyVoted] = useState();

    const getCandidates = async () => {
        axios.get("/api/v1/congress/houseRace/" + state + "/" + district + "/" + year)
            .then((result) => {
                let reps = result.data;
                setCandidates(reps);
                reps.forEach((r, currentIdx) => {
                    axios.get("/api/v1/uservote/voted/40/" + r.id)
                        .then((result2) => {
                            if (result2.data) {
                                setAlreadyVoted(r.id);
                            }
                        })
                        .catch((err) => { });
                    axios.get("/api/v1/uservote/votes/40/" + r.id)
                        .then((result3) => {
                            setVotes(prevVotes =>
                                prevVotes.map((vote, index) =>
                                    index == currentIdx ? result3.data : vote
                                ));
                        })

                })
            })
            .catch((err) => console.log(err));
    };

    const [metaDocId, setMetaDocId] = useState();

    const formatText = (text, singleOrDouble) => {
        if (!text) return "";

        // Replace **bold** section numbers in EOs text
        let formatted = text.replace(/\*\*(.*?)\*\*\."(.*?)\."/g, "<strong><i>$1 - $2</i></strong><br/><br/>");

        //regular bold text
        formatted = formatted.replace(/\*\*(.*?)\*\*/g, "<strong><i>$1</i></strong><br/><br/>");

        // Add indentation for lines starting with *
        formatted = formatted.replace(
            /(^|\n)\*(.*)/g,
            '$1<span style="margin-left: 2em; display: block;">$2</span>'
        );

        // Indent lines starting with numbers like 1., 2), 3:
        formatted = formatted.replace(
            /(^|\n)\d+[.):](.*)/g,
            '$1<span style="margin-left: 2em; display: block;">$&</span>'
        );

        //Web reference
        formatted = formatted.replace(
            /\(\[(.*)\]\((http.*)\)\)/g,
            '[<a href="$2">$1</a>]'
        )

        // Replace newlines with <br/>
        //formatted = formatted.replace(/\n\n/g, "\n");
        if (singleOrDouble === 's') {
            formatted = formatted.replace(/\n/g, "<br/>");
        } else {
            formatted = formatted.replace(/\n/g, "<br/><br/>");
        }



        return formatted;
    };

    const [showSummary, setShowSummary] = useState([true, true, true, true, true, true]);
    const toggleShowSummary = (targetIndex) => {
        setShowSummary(prevShowSummary =>
            prevShowSummary.map((show, index) =>
                index === targetIndex ? !show : show
            )
        )
    }

    const [showRed, setShowRed] = useState([false, false, false, false, false, false]);
    const toggleShowRed = (targetIndex) => {
        setShowRed(prevShowRed =>
            prevShowRed.map((show, index) =>
                index === targetIndex ? !show : show
            ))
    }

    const [showBlue, setShowBlue] = useState([false, false, false, false, false, false]);
    const toggleShowBlue = (targetIndex) => {
        setShowBlue(prevShowBlue =>
            prevShowBlue.map((show, index) =>
                index === targetIndex ? !show : show
            ))
    }



    const handleVoteAction = (a) => {
        if (alreadyVoted == a) {
            setAlreadyVoted(0);
        }
        getCandidates();
    }

    useEffect(() => {
        getCandidates();
    }, []);

    return (
        <MainLayout>
            <title>{"2026 " + state + (district > 0 ? district : ' at-large') + ' US House Race'}</title>
            <div>
                <div>
                    <Link to="/House2026.html">Back to List</Link>
                </div>
                <div className="content-image">
                    <center>
                        <h2><center>{state} : {district > 0 ? district : ' at-large'}</center></h2>
                        <img src={"/graphics/flags/Flag_of_" + state.replace(' ', '_') + ".svg"} alt={state} />
                    </center>
                </div>
                <div className="column-container">
                    {candidates.map((candidate, index) => (
                        <div key={index} className="column">
                            <h2>{candidate.name}</h2>
                            <h3>{candidate.party}</h3>


                            {(alreadyVoted == candidate.id || !alreadyVoted) &&
                                <VoteTile collectionGroupId={40} documentId={candidate.id} documentSubject={""} sendValueBack={(e) => handleVoteAction(e)} />
                            }

                            <button className="accordion color-neutral" onClick={() => toggleShowSummary(index, !showSummary[index])}>
                                <img className={showSummary[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
                                <img className={!showSummary[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
                                <h4>Summary</h4>
                            </button>

                            <div className="accordion-panel" style={{ display: showSummary[index] ? "inherit" : "none" }}>
                                <div
                                    dangerouslySetInnerHTML={{ __html: formatText(candidate.website ? candidate.summary : noWebsiteMessage, 's') }}
                                />
                            </div>
                            <button className="accordion color-conservative" onClick={() => toggleShowRed(index, !showRed[index])}>
                                <img className={showRed[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
                                <img className={!showRed[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
                                <h4>Conservative Opinion</h4>
                            </button>
                            <div className="accordion-panel" style={{ display: showRed[index] ? "inherit" : "none" }}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: formatText(candidate.website ? candidate.conservativeOpinion : noWebsiteMessage, 's'),
                                    }}
                                />
                            </div>
                            <div>
                                <button className="accordion color-liberal" onClick={() => toggleShowBlue(index, !showBlue[index])}>
                                    <img className={showBlue[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
                                    <img className={!showBlue[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
                                    <h4>Liberal Opinion</h4>
                                </button>
                                <div className="accordion-panel" style={{ display: showBlue[index] ? "inherit" : "none" }}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: formatText(candidate.website ? candidate.liberalOpinion : noWebsiteMessage, 's'),
                                        }}
                                    />
                                </div>

                            </div>
                        </div>
                    ))}

                </div>
                <br /><br />

                {metaDocId && (
                    <CommentList collectionGroupId={5} documentId={metaDocId} />
                )}

            </div>
        </MainLayout >

    )
}

export default HouseSideBySide
